import DynamicList from "./components/DynamicList";


function MyLists() {

    return (

            <DynamicList />

    )
}

export default MyLists;
